import { Trans } from '@gamiphy/react-i18n';
import {
  Box, Typography,
} from '@mui/material';
import {
  useTheme,
} from '@mui/material/styles';
import { observer } from 'mobx-react';
import React from 'react';
import Confetti from '../assets/Confetti';

const Celebration: React.FC<{ convertedPoints: number }> = ({ convertedPoints }) => {
  const theme = useTheme();

  return (
    <Box display="flex" gap={2} alignItems="center" width="100%">
      <Confetti color={theme.palette.primary.main} />
      <Box>
        <Typography fontWeight={700} fontSize={16}>
          <Trans
            i18nKey="redeem.discountCodeApplied.didIt"
            defaults="Yay! You Did It!"
          />
        </Typography>
        <Typography fontSize={16}>
          <Trans
            i18nKey="redeem.discountCodeApplied.usedPoints"
            defaults="You used your <colored>{{points, gems}}</colored>"
            components={{
              colored: <Box component="span" color="primary.main" />,
            }}
            values={{
              points: convertedPoints,
            }}
          />
        </Typography>
      </Box>
    </Box>
  );
};

export default observer(Celebration);
